import LogRocket from "logrocket";

var LOGROCKET_APP_ID = "9cz1ti/fanzones-portal";
var TOKEN_KEY = "token";
var USER_NAME_KEY = "userName";
var initialized = false;

function getEnvironment() {
  var host = window.location.host;

  if (host.indexOf("localhost") > -1 || host.indexOf(".dev") > -1) {
    return "development";
  }
  if (host.indexOf(".stage") > -1) {
    return "staging";
  }
  return "production";
}

function normalizeBase64(input) {
  var output = input.replace(/-/g, "+").replace(/_/g, "/");

  while (output.length % 4 !== 0) {
    output += "=";
  }

  return output;
}

function decodeTokenPayload(token) {
  if (!token) {
    return null;
  }

  try {
    var payload = token.split(".")[1];
    if (!payload) {
      return null;
    }

    return JSON.parse(atob(normalizeBase64(payload)));
  } catch (error) {
    console.error("[LogRocket] Error decoding token payload:", error);
    return null;
  }
}

function getUserNameFromPayload(payload) {
  if (!payload) {
    return "";
  }

  return payload.user_name || payload.userName || payload.nameid || "";
}

function resolveUserName(token) {
  var storedUserName = localStorage.getItem(USER_NAME_KEY);
  if (storedUserName) {
    return storedUserName;
  }

  var payload = decodeTokenPayload(token || localStorage.getItem(TOKEN_KEY));
  var userName = getUserNameFromPayload(payload);

  if (userName) {
    localStorage.setItem(USER_NAME_KEY, userName);
  }

  return userName;
}

function sanitizeRequest(request) {
  if (request && request.headers) {
    if (request.headers.Authorization) {
      request.headers.Authorization = "***";
    }
    if (request.headers.authorization) {
      request.headers.authorization = "***";
    }
  }

  return request;
}

function sanitizeResponse(response) {
  if (response && response.data && response.data.password) {
    response.data.password = "***";
  }
  if (response && response.body && response.body.password) {
    response.body.password = "***";
  }

  return response;
}

function ensureInitialized() {
  if (initialized) {
    return;
  }

  LogRocket.init(LOGROCKET_APP_ID, {
    environment: getEnvironment(),
    dom: {
      inputSanitizer: true,
    },
    network: {
      requestSanitizer: sanitizeRequest,
      responseSanitizer: sanitizeResponse,
    },
  });

  initialized = true;
}

function identifyLogRocketUser(moduleName, token) {
  var userName = resolveUserName(token);
  if (!userName) {
    return null;
  }

  ensureInitialized();
  LogRocket.identify(userName, {
    name: userName,
    userName: userName,
    module: moduleName || "unknown",
  });

  return userName;
}

function initLogRocket(moduleName) {
  ensureInitialized();
  return identifyLogRocketUser(moduleName);
}

function syncLogRocketUser(token, moduleName) {
  return identifyLogRocketUser(moduleName, token);
}

export { initLogRocket, identifyLogRocketUser, syncLogRocketUser };
export default LogRocket;
